/**
 * Rutas de la aplicación
 * Centraliza todas las rutas para facilitar el mantenimiento
 */

export const ROUTES = {
  HOME: '/',
  ABOUT: '/nosotros',
  PROGRAMS: '/propuesta-educativa',
  WORKSHOPS: '/talleres',
  ADMISSIONS: '/admision-2026',
  NEWS: '/noticias',
  SALAS: '/salas',
  CONCURSOS: '/concursos',
  CONTACT: '/contacto',
  NOT_FOUND: '*'
};
